@if ($metaData(); as metaData) {
    @for (entry of $entries(); track entry.key) {
        <div class="cm-meta-data-entry">
            <cm-input-container>
                <span cm-inline-label>Key</span>
                <input
                    cm-input
                    class="cm-key-input"
                    [value]="entry.key"
                    (blur)="renameKey(entry.key, $event.target)"
                    (keydown.enter)="$event.target.blur()"
                    placeholder="key"
                />
            </cm-input-container>
            <cm-value-slot [node]="metaData" [key]="entry.key" [label]="''" [schema]="entry.schema" [jsonEditSingleParams]="false"></cm-value-slot>
            <i (click)="removeMetaData(entry.key)" class="far fa-times-circle cm-button" [matTooltip]="'Remove'"></i>
        </div>
    }
}
<cm-button class="cm-action-button" [matMenuTriggerFor]="addMenu">
    <ng-container cm-text> Add Meta Data </ng-container>
</cm-button>
<mat-menu #addMenu>
    <button mat-menu-item (click)="addMetaData('string')">String</button>
    <button mat-menu-item (click)="addMetaData('number')">Number</button>
    <button mat-menu-item (click)="addMetaData('boolean')">Boolean</button>
    <button mat-menu-item (click)="addMetaData('json')">JSON</button>
</mat-menu>
